/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserOperatorSelectionsRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { departureOperatorCheckedActionCreator } from '../../../wizard/target-node-impc-selector/redux/actions/DeparturePostalOperatorActions';
import { arrivalMailProcessingCenterCheckedActionCreator } from '../../../wizard/target-node-impc-selector/redux/actions/ArrivalPostalOperatorActions';
import {
  saveGlobalSelectionOperatorRequestActionCreator,
  deleteGlobalSelectionOperatorRequestActionCreator,
  setTabButtonStatus,
} from '../redux/actions/AdminDashboardActions';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import Icons from '../../../../core/modules/common/components/Icons';
import DeleteModal from '../../../common/components/DeleteModal';
import { createPresetSelections, createPresetSelectionsOnSave } from '../../../react-table/helpers/utils';
import EditIMPCSelectionModal from '../../../wizard/target-node-impc-selector/components/EditIMPCSelectionModal';
import Button from '../../../../core/modules/common/components/Button';
import SaveSelectionModal from '../components/SaveSelectionModal';
import WarningModal from '../../../common/components/WarningModal';
import { getDeparturePostalOperators } from '../../../wizard/target-node-impc-selector/redux/selectors/PostalOperatorSelectors';

function operatorSelectorSelector(props, state) {
  switch (props.operatorType) {
    case OperatorTypes.DEPARTURE:
      return state.postalOperatorSelector.departure;
    case OperatorTypes.ARRIVAL:
      return state.postalOperatorSelector.arrival;
    default:
      return state.postalOperatorSelector.departure;
  }
}

const mapStateToProps = (state, props) => ({
  selections: operatorSelectorSelector(props, state).selections,
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
});

class AdminPresetOperatorSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DEPARTURE: { activeSelection: 'Your last selection' },
      ARRIVAL: { activeSelection: 'Your last selection' },
      newSelection: '',
      newPresetButtonDisabled: false,
      checkedMailProcessingCenters: [],
      name: '',
      showDeleteSelectionModal: false,
      showEditSelectionModal: false,
      showSaveSelectionModal: false,
      showOverwriteNewSelectionModal: false,
      showOverwriteSelectionModal: false,
      nameUi: '',
      saveSelectionSelections: [],
      saveSelectionCheckedMailProcessingCenters: [],
    };
  }

  componentDidMount() {
    const {
      operatorType,
    } = this.props;
    this.props.fetchUserOperatorSelectionsRequestActionCreator(operatorType);
  }

  componentDidUpdate(prevProps) {
    const { selections } = this.props;
    if (selections !== prevProps.selections) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        newSelection: selections,
      });
    }
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  // eslint-disable-next-line react/sort-comp
  applySelection = (e, selection) => {
    const reportDef = {
      locationType: 'IMPC',
    };
    if (this.props.operatorType === OperatorTypes.DEPARTURE) {
      this.props
        .departureOperatorCheckedActionCreator(
          createPresetSelections(selection.operatorCodes, this.props.operators),
          reportDef,
        );
    } else if (this.props.operatorType === OperatorTypes.ARRIVAL) {
      this.props
        .arrivalMailProcessingCenterCheckedActionCreator(
          createPresetSelections(selection.operatorCodes, this.props.operators),
          reportDef,
        );
    }
    this.setState({
      [this.props.operatorType]: { activeSelection: selection.name },
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      showDeleteSelectionModal: true,
      nameUi: selection.name,
    });
  };

  deleteSelection = () => {
    this.props.deleteGlobalSelectionOperatorRequestActionCreator(this.state.nameUi);
    this.onCloseModal();
  };

  openEditSelectionModal = (e, selection) => {
    e.stopPropagation();
    this.setState({
      showEditSelectionModal: true,
      saveSelectionSelections: this.props.selections,
      saveSelectionCheckedMailProcessingCenters: createPresetSelectionsOnSave(this.props.checked, this.props.departurePostalOperatorsNodes),
      nameUi: selection.name,
    });
  };

  editSelection = ({ name, checkedMailProcessingCenters }) => {
    this.setState({
      name,
      checkedMailProcessingCenters,
    });
    if (name && name !== this.state.nameUi) {
      this.setState({
        showOverwriteNewSelectionModal: true,
        showOverwriteSelectionModal: false,
      });
    } else {
      this.setState({
        showOverwriteNewSelectionModal: false,
        showOverwriteSelectionModal: true,
      });
    }
    this.setState({
      newPresetButtonDisabled: false,
    });
    this.closeEditSelectionModal();
  };

  overwriteNewSelection = () => {
    this.props.saveGlobalSelectionOperatorRequestActionCreator(this.state.name, 'I', this.props.operatorType, this.state.checkedMailProcessingCenters);
    this.props.setTabButtonStatus(false);
    this.onCloseNewOverwriteModal();
  };

  overwriteSelection = () => {
    this.props.saveGlobalSelectionOperatorRequestActionCreator(this.state.nameUi, 'I', this.props.operatorType, this.state.checkedMailProcessingCenters);
    this.props.setTabButtonStatus(false);
    this.onCloseOverwriteModal();
  };

  closeEditSelectionModal = () => {
    this.setState({
      showEditSelectionModal: false,
    });
  };

  onCloseOverwriteModal = () => {
    this.setState({
      showOverwriteSelectionModal: false,
    });
  };

  onCloseNewOverwriteModal = () => {
    this.setState({
      showOverwriteNewSelectionModal: false,
    });
  };

  openSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: true,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name }) => {
    const newPreset = [...this.props.selections];
    newPreset.unshift({
      name, scope: 'GLOBAL', direction: 'I', operatorCodes: [],
    });
    this.setState({
      newSelection: newPreset,
      newPresetButtonDisabled: true,
    });
    this.closeSaveSelectionModal();
  };

  render() {
    const {
      operatorType,
    } = this.props;
    const {
      newSelection,
      newPresetButtonDisabled,
      showDeleteSelectionModal,
      showEditSelectionModal,
      showSaveSelectionModal,
      showOverwriteNewSelectionModal,
      showOverwriteSelectionModal,
      saveSelectionSelections,
      saveSelectionCheckedMailProcessingCenters,
    } = this.state;
    return (
      <div className="operator-sidebar-div">
        <div className="selection-title">
          <FormattedMessage
            tagName="h5"
            id="app.selection.admin.list.operator.title.label"
            values={{ operatorType }}
          />
          <Button
            className="sidebar-new-preset-button"
            text="app.selection.new.preset"
            onClick={() => this.openSaveSelectionModal()}
            disabled={newPresetButtonDisabled}
          />
        </div>
        {newSelection && newSelection.length > 0 ? (
          <div className="user-selections">
            {showDeleteSelectionModal &&
              <DeleteModal
                headerFormattedMessageId="app.warning.delete.save.operator.selection"
                onCloseModal={this.onCloseModal}
                deleteSelection={this.deleteSelection}
              />
              }
            {showOverwriteSelectionModal &&
              <WarningModal
                headerFormattedMessageId="app.warning.save.overwrite.operator.selection"
                onCloseModal={this.onCloseOverwriteModal}
                deleteSelection={this.overwriteSelection}
              />
              }
            {showOverwriteNewSelectionModal &&
              <WarningModal
                headerFormattedMessageId="app.warning.save.new.overwrite.operator.selection"
                onCloseModal={this.onCloseNewOverwriteModal}
                deleteSelection={this.overwriteNewSelection}
              />
              }
            {showEditSelectionModal &&
              <EditIMPCSelectionModal
                saveSelection={this.editSelection}
                closeModal={this.closeEditSelectionModal}
                checkedMailProcessingCenters={saveSelectionCheckedMailProcessingCenters}
                selections={saveSelectionSelections}
                name={this.state.nameUi}
              />
              }
            {showSaveSelectionModal &&
              <SaveSelectionModal
                saveSelection={this.saveSelection}
                closeModal={this.closeSaveSelectionModal}
                selections={this.props.selections}
                title="app.save.empty.new.preset"
              />
              }
            <ul className="global-ul">
              { newSelection
                  .filter(selection => selection.scope === 'GLOBAL' && selection.name !== 'Your last selection')
                  .map(selection => (
                    <li
                      key={selection.name}
                      onClick={e => this.applySelection(e, selection)}
                      className={this.state[operatorType].activeSelection === selection.name ? 'active' : ''}
                    >
                      <button
                        className="global-icon"
                        key={selection.name}
                        onClick={e => this.openDeleteSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="trash-o" />
                      </button>
                      <button
                        className="global-icon-edit"
                        onClick={e => this.openEditSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="save" />
                      </button>
                      {selection.name}
                    </li>
                  )) }
            </ul>
          </div>
          ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserOperatorSelectionsRequestActionCreator,
  deleteGlobalSelectionOperatorRequestActionCreator,
  saveGlobalSelectionOperatorRequestActionCreator,
  departureOperatorCheckedActionCreator,
  arrivalMailProcessingCenterCheckedActionCreator,
  setTabButtonStatus,
}, dispatch);

AdminPresetOperatorSidebarContainer.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    operatorCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  fetchUserOperatorSelectionsRequestActionCreator: PropTypes.func,
  saveGlobalSelectionOperatorRequestActionCreator: PropTypes.func,
  deleteGlobalSelectionOperatorRequestActionCreator: PropTypes.func,
  departureOperatorCheckedActionCreator: PropTypes.func,
  arrivalMailProcessingCenterCheckedActionCreator: PropTypes.func,
  operatorType: PropTypes.string,
  operators: PropTypes.arrayOf(PropTypes.object),
  checked: PropTypes.arrayOf(PropTypes.string),
  setTabButtonStatus: PropTypes.func,
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
};

export const ConnectedAdminPresetOperatorSidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminPresetOperatorSidebarContainer);

export default (ConnectedAdminPresetOperatorSidebarContainer);
